// import API from "../../../app/api";

// export const getproductlist = async () => {
//   try {
//     const res = await API.get(`/qualities/floor-covering`);
//     if (res.data?.success) {
//       return res.data?.data || []; // ✅ FIXED HERE
//     }
//     return [];
//   } catch (error) {
//     console.error("Product List Error:", error);
//     return [];
//   }
// };


import API from "../../../app/api";

export const getproductlist = async (slug) => {
  try {
    const res = await API.get(`/qualities/${slug}`);

    if (res.data?.success) {
      return res.data.data;
    }

    return [];
  } catch (error) {
    console.error("Product List Error:", error);
    throw error;
  }
};
